
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/vision-strategy",
      function () {
        return require("private-next-pages/company/vision-strategy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company/vision-strategy"])
      });
    }
  